import React from 'react';
import styles from './Card.module.css';

const Card = ({
    children,
    variant = 'default',
    padding = 'medium',
    hover = false,
    className = '',
    ...props
    }) => {
    const classNames = [
        styles.card,
        styles[variant],
        styles[`padding-${padding}`],
        hover && styles.hover,
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={classNames} {...props}>
        {children}
        </div>
    );
};

export default Card;